import React, { useState, useEffect } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import AvailablePtoPanel from "../common/AvailablePtoPanel";
import PtoDetailsPanel from "./PtoDetailsPanel";
import { myPtoDetails } from "../api/PtoDetailsApi";

const DashboardPage = ({ profile }) => {
  const [loading, setLoading] = useState(true);
  const [ptoDetails, setPtoDetails] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Load PTO details whenever profile changes
    const loadData = async () => {
      setLoading(true);
      setError(null);
      setPtoDetails(null);
      
      try {
        let data;

        data = await myPtoDetails(profile.dataEmployeeId);
        
        setPtoDetails(data);
      } catch (error) {
        console.error("Error loading PTO details:", error);
        setError(error.message || "PTO Details did not load");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [profile]);

  // If we're loading, show loading state
  if (loading) {
    return (
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg="4">
            <AvailablePtoPanel isLoading={true} data={0} />
          </Col>
        </Row>
      </Container>
    );
  }

  // If there's an error, show error message
  if (error || !ptoDetails) {
    return (
      <Container fluid>
        <Row className="justify-content-center mt-4">
          <Col lg="8">
            <Alert variant="danger">
              <Alert.Heading>Error Loading PTO Details</Alert.Heading>
              <p>{error || "PTO details not found"}</p>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  // Otherwise show the PTO details
  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Col lg="4">
          <AvailablePtoPanel 
            isLoading={loading} 
            data={ptoDetails?.totals?.availableHours || 0} 
          />
        </Col>
      </Row>
      
      <Row className="justify-content-center">
        <Col lg="8">
          <PtoDetailsPanel data={ptoDetails} />
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardPage;